module.exports = "/images/london-13.jpg";